import { useEvent } from '@emerald-works/react-event-bus-client'
import { Radio, RadioGroup, FormControlLabel, FormControl, CircularProgress } from '@mui/material'
import React, { useState } from 'react'
import { BannerStatic } from '../../../components'

const RoleSelector = ({ user, role, setRole, roles, userPoolId, onRoleChanged }) => {
  const [value, setValue] = useState(role)

  const [updateRoleUser] = useEvent([
    {
      eventName: 'adminUpdateRoleUser',
      onSuccess: payload => {
        setRole(payload.role)
        BannerStatic.show({ label: 'Toolkit User changed successfully' })
        onRoleChanged(payload.role)
      },
      onError: (e) => {
        console.log('error toggling user role', e)
        BannerStatic.show({ label: 'Error while attempting to change the Toolkit User role', isError: true })
      }
    }
  ])

  const handleChange = ev => {
    setValue(ev.target.value)
    updateRoleUser.trigger({ userPoolId, username: user.username, role: ev.target.value, previousRole: role })
  }

  const renderRadios = () => roles.map((item, index) => (
    <FormControlLabel
      key={`radio-${index}`}
      value={item}
      control={<Radio color='primary' />}
      label={item === 'enterprise' ? 'Reader' : item}
      disabled={updateRoleUser.isWorking}
    />
  ))

  return (
    <>
      {roles && (
        <FormControl variant='outlined' component='fieldset'>
          <RadioGroup row aria-label='role' name='role' value={value} onChange={handleChange}>
            {renderRadios()}
            {updateRoleUser.isWorking && <CircularProgress size={20} color='primary' />}
          </RadioGroup>
        </FormControl>
      )}
    </>
  )
}

export default RoleSelector
